import React from "react";
import {
  FaCamera,
  FaCheck,
  FaEnvelope,
  FaExternalLinkAlt,
  FaImages,
  FaLanguage,
  FaMobileAlt,
  FaSearch,
} from "react-icons/fa";

import Footer from "../../components/Footer/footer";
import { deepMerge, useSiteContent } from "../../content/SiteContentContext";

const CONTACT_EMAIL = "astenius@live.com";

const DEMO_URL =
  "https://photography-premium.spiderlegsproductions.com/";

const copy = {
  fi: {
    badge:
      "Photography Premium · Verkkosivut valokuvaajille",

    title:
      "Verkkosivut valokuvaajalle, jonka kuvat ansaitsevat paremman esillepanon",

    lead:
      "Rakennan valokuvaajille täysin räätälöityjä, visuaalisia ja nopeita verkkosivuja, joissa portfolio, palvelut, hinnasto, yhteydenotto ja hakukonenäkyvyys muodostavat yhden selkeän kokonaisuuden. Sivustoa ei soviteta valmiiseen sivupohjaan, vaan ilme ja rakenne tehdään kuvaajan oman työn ja brändin ympärille. Photography Premium -toteutukset alkavat 1 490 eurosta.",

    primaryCta:
      "Katso Photography Premium -demo",

    secondaryCta:
      "Pyydä tarjous",

    trust: [
      "Portfolio edellä",
      "Mobiili ensin",
      "WordPress-hallinta",
      "SEO-perusta mukana",
    ],

    whoTitle:
      "Kenelle Photography Premium sopii?",

    whoLead:
      "Erityisesti kuvaajalle, jonka sivuston pitää näyttää yhtä hyvältä kuin hänen työnsä ja tehdä yhteydenotosta asiakkaalle helppoa.",

    who: [
      "Hää- ja parikuvaajat",
      "Henkilö-, perhe- ja lifestyle-kuvaajat",
      "Yritys- ja brändikuvaajat",
      "Studio- ja muotokuvaajat",
      "Kuvaajat, joiden nykyinen sivusto on vanhentunut, hidas tai hankala mobiilissa",
      "Kuvaajat, jotka haluavat kehittää näkyvyyttään Googlessa",
    ],

    featuresTitle:
      "Mitä valokuvaajan sivustolle voidaan rakentaa?",

    features: [
      {
        icon: "portfolio",
        title:
          "Visuaalinen portfolio",
        text:
          "Kuvat nostetaan pääosaan selkeällä, rauhallisella ja responsiivisella portfoliolla, joka toimii yhtä hyvin mobiilissa kuin isolla näytöllä.",
      },
      {
        icon: "camera",
        title:
          "Palvelut ja hinnasto",
        text:
          "Kuvaukset, paketit, hinnat ja käytännön tiedot esitetään niin, että asiakkaan on helppo ymmärtää mitä tarjoat ja kenelle.",
      },
      {
        icon: "mobile",
        title:
          "Nopea mobiilikokemus",
        text:
          "Rakenne, kuvat ja käyttöliittymä suunnitellaan mobiili edellä. Tavoitteena on nopea, selkeä ja viimeistelty käyttökokemus.",
      },
      {
        icon: "search",
        title:
          "SEO ja löydettävyys",
        text:
          "Sivurakenne, otsikot, metat, hakukoneille luettava sisältö ja tarvittaessa erilliset palvelu- ja paikkaländärit huomioidaan alusta asti.",
      },
      {
        icon: "language",
        title:
          "Kieliversiot",
        text:
          "Sivusto voidaan toteuttaa yhdellä tai useammalla kielellä. Esimerkiksi suomi + englanti, suomi + ruotsi tai muu asiakkaalle sopiva yhdistelmä.",
      },
      {
        icon: "contact",
        title:
          "Yhteydenotto ja hallinta",
        text:
          "Selkeä tarjouspyyntöpolku, yhteydenottolomake ja WordPress-sisällönhallinta tekevät sivustosta helpon sekä asiakkaalle että kuvaajalle.",
      },
    ],

    demoEyebrow:
      "Photography Premium · Demo",

    demoTitle:
      "Katso miltä moderni valokuvaajan verkkosivusto voi näyttää",

    demoLead:
      "Photography Premium -demo näyttää yhden mahdollisen rakenteen ja visuaalisen suunnan. Lopullinen sivusto ei ole valmis kaikille samanlaisena annettava teema, vaan värit, kuvat, typografia, tekstit, palvelut ja sisältö mukautetaan asiakkaan omaan brändiin.",

    demoItems: [
      "Etusivu ja vahva kuvallinen hero",
      "Portfolio",
      "Kuvaukset / palvelut",
      "Hinnasto",
      "Kuvaaja / esittely",
      "Studio / toimitila tarvittaessa",
      "Yhteys ja tarjouspyyntö",
      "FI / EN -kieliversiot",
      "Ivory / Noir -teemavaihtoehdot demossa",
      "Responsiivinen mobiili- ja desktop-toteutus",
    ],

    demoCta:
      "Avaa Photography Premium -demo",

    packagesEyebrow:
      "Toteutusvaihtoehdot",

    packagesTitle:
      "Valitse sopiva laajuus",

    packagesLead:
      "Paketit kuvaavat projektin laajuutta, eivät valmista sivupohjaa. Jokainen sivusto suunnitellaan kuvaajan oman brändin, kuvien, palveluiden ja tavoitteiden ympärille, ja sisältöjä sekä ominaisuuksia voidaan lisätä, poistaa tai yhdistellä tarpeen mukaan.",

    recommended:
      "Suosituin kokonaisuus",

    packages: [
      {
        id:
          "essential",
        name:
          "Kevyt",
        prefix:
          "alk.",
        price:
          "1 490 €",
        description:
          "Ammattimainen sivusto, joka sisältää olennaiset sivut oman työn ja palveluiden esittelyyn.",
        features: [
          "Etusivu",
          "Portfolio",
          "Palvelut / kuvaukset",
          "Hinnasto tarvittaessa",
          "Kuvaaja / esittely",
          "Yhteys + lomake",
          "Some- ja yhteystiedot",
          "1 kieliversio",
          "WordPress-sisällönhallinta",
          "Hakukoneoptimoinnin perusteet",
        ],
      },
      {
        id:
          "premium",
        name:
          "Premium",
        prefix:
          "alk.",
        price:
          "2 490 €",
        featured:
          true,
        description:
          "Laajempi kokonaisuus kuvaajalle, joka haluaa enemmän sisältöä, toimintoja ja vahvemman pohjan hakukonenäkyvyydelle.",
        features: [
          "Kaikki Kevyt-paketista",
          "2 kieliversiota",
          "Asiakaspalautteet",
          "UKK",
          "Studio / toimitila -sivu tarvittaessa",
          "Laajempi sisällönhallinta",
          "Lisätoiminnot ja CTA:t",
          "Kävijäseuranta",
          "Evästehallinta",
          "Laajempi hakukonenäkyvyys",
          "3 SEO-ländäriä",
        ],
      },
      {
        id:
          "custom",
        name:
          "Räätälöity",
        prefix:
          "alk.",
        price:
          "3 490 €",
        description:
          "Laajempi täysin räätälöity kokonaisuus, kun projekti tarvitsee yksilöllisiä sivuja, toimintoja, integraatioita tai tavallista laajemman näkyvyysratkaisun.",
        features: [
          "Kaikki Premium-paketista",
          "Useita kieliversioita",
          "Yksilölliset sivut ja osiot",
          "5–10+ SEO-ländäriä",
          "Laajempi näkyvyyskokonaisuus",
          "Ajanvarausratkaisut",
          "Räätälöidyt integraatiot",
          "Erikoislomakkeet",
          "Laajempi sisältöjen siirto",
        ],
      },
    ],

    seoEyebrow:
      "Näkyvyys Googlessa",

    seoTitle:
      "Hyvä portfolio ei yksin auta, jos asiakas ei löydä sitä",

    seoLead:
      "Sivusto voidaan rakentaa myös aktiivisesti uusia asiakkaita varten. Palvelut, kuvat, otsikot ja sivurakenne suunnitellaan niin, että hakukoneet ymmärtävät mitä tarjoat ja millä alueella toimit.",

    seoLandingTitle:
      "SEO-ländärit",

    seoLandingText:
      "SEO-ländäri on erillinen palvelu- tai paikkasivu, joka rakennetaan tietyn haun ympärille. Premiumiin kuuluu kolme SEO-ländäriä ja Räätälöityyn 5–10 tai enemmän tarpeen mukaan.",

    seoExamples:
      "Esimerkiksi: Hääkuvaaja Helsinki · Yrityskuvaaja Espoo · Henkilökuvaus Vantaa",

    processTitle:
      "Miten projekti etenee?",

    process: [
      {
        title:
          "1. Tyyli ja tavoitteet",
        text:
          "Käydään läpi nykyinen sivusto, kuvaustyyli, palvelut, asiakkaat ja se, mitä uuden sivuston pitää saada aikaan.",
      },
      {
        title:
          "2. Design ja staging",
        text:
          "Rakennan sivuston staging-osoitteeseen. Näet työn etenemisen ja pääset kommentoimaan rakennetta, sisältöä ja visuaalista ilmettä ennen julkaisua.",
      },
      {
        title:
          "3. Viimeistely ja julkaisu",
        text:
          "Sisällöt, mobiilinäkymät, lomakkeet, perus-SEO ja tekninen toimivuus tarkistetaan ennen kuin uusi sivusto julkaistaan.",
      },
    ],

    faqTitle:
      "Usein kysyttyä valokuvaajan verkkosivuista",

    faqLead:
      "Yleisimmät kysymykset ennen Photography Premium -projektin aloittamista.",

    faq: [
      {
        q:
          "Paljonko valokuvaajan verkkosivut maksavat?",
        a:
          "Photography Premium -toteutukset alkavat 1 490 eurosta. Premium alkaa 2 490 eurosta ja laajempi Räätälöity kokonaisuus 3 490 eurosta. Lopullinen hinta riippuu sivumäärästä, kieliversioista, sisällöistä ja lisätoiminnoista.",
      },
      {
        q:
          "Voinko päivittää kuvia ja sisältöä itse?",
        a:
          "Kyllä. Toteutukseen voidaan sisällyttää WordPress-sisällönhallinta, jonka kautta esimerkiksi portfolioita, tekstejä, palveluita ja muita sisältöjä voidaan päivittää ilman koodin muokkaamista.",
      },
      {
        q:
          "Onko sivusto samanlainen kuin Photography Premium -demo?",
        a:
          "Demo näyttää yhden mahdollisen rakenteen ja visuaalisen suunnan. Varsinainen sivusto mukautetaan asiakkaan kuviin, väreihin, typografiaan, palveluihin, teksteihin ja omaan brändiin.",
      },
      {
        q:
          "Voidaanko vanhan sivuston sisältö siirtää?",
        a:
          "Kyllä. Vanhoja tekstejä, kuvia ja muuta käyttökelpoista sisältöä voidaan siirtää uuteen kokonaisuuteen. Laajempi sisältöjen siirto voidaan sopia osaksi projektia.",
      },
      {
        q:
          "Saako sivuston useammalla kielellä?",
        a:
          "Kyllä. Kevyt sisältää yhden kieliversion ja Premium kaksi. Tarvittaessa sivusto voidaan tehdä useammalla kielellä.",
      },
      {
        q:
          "Voiko sivustolle lisätä ajanvarauksen?",
        a:
          "Kyllä. Ajanvaraus voidaan toteuttaa projektin tarpeen mukaan joko valmiin palvelun integraationa tai laajempana räätälöitynä ratkaisuna.",
      },
      {
        q:
          "Mitä SEO-ländäri tarkoittaa?",
        a:
          "SEO-ländäri on tietylle palvelulle tai paikalliselle haulle tehty oma sivu. Sen tarkoitus on auttaa sivustoa löytymään esimerkiksi haulla 'hääkuvaaja Helsinki' tai 'yrityskuvaaja Espoo'.",
      },
      {
        q:
          "Kauanko sivuston tekeminen kestää?",
        a:
          "Aikataulu sovitaan projektikohtaisesti sisällön, kieliversioiden ja laajuuden mukaan. Staging-version avulla asiakas näkee työn etenemisen jo ennen julkaisua.",
      },
      {
        q:
          "Saako sivustolle hostingin ja ylläpidon?",
        a:
          "Kyllä. Hosting ja jatkuva tekninen ylläpito voidaan sopia erikseen osaksi kokonaisuutta.",
      },
    ],

    finalTitle:
      "Haluatko sivuston, joka näyttää yhtä hyvältä kuin kuvasi?",

    finalLead:
      "Tutustu ensin Photography Premium -demoon. Jos suunta tuntuu omalta, lähetä tarjouspyyntö ja kerro lyhyesti nykyisestä sivustostasi ja siitä, mitä haluaisit uudistaa.",
  },

  en: {
    badge:
      "Photography Premium · Websites for photographers",

    title:
      "A website for photographers whose work deserves a better presentation",

    lead:
      "I build fully custom, visual and fast websites for photographers, combining portfolio, services, pricing, contact and search visibility into one clear experience. The site is not fitted into an off-the-shelf template; its structure and visual direction are built around the photographer's own work and brand. Photography Premium projects start from €1,490.",

    primaryCta:
      "View the Photography Premium demo",

    secondaryCta:
      "Request a quote",

    trust: [
      "Portfolio first",
      "Mobile first",
      "WordPress management",
      "SEO foundation included",
    ],

    whoTitle:
      "Who is Photography Premium for?",

    whoLead:
      "Especially for photographers whose website needs to look as polished as their work and make it easy for potential clients to get in touch.",

    who: [
      "Wedding and couple photographers",
      "Portrait, family and lifestyle photographers",
      "Corporate and brand photographers",
      "Studio and portrait photographers",
      "Photographers with an outdated, slow or difficult mobile website",
      "Photographers who want to improve their visibility in search",
    ],

    featuresTitle:
      "What can be built into a photographer website?",

    features: [
      {
        icon: "portfolio",
        title:
          "Visual portfolio",
        text:
          "Your images take centre stage in a calm, responsive portfolio designed to work beautifully on both mobile and large screens.",
      },
      {
        icon: "camera",
        title:
          "Services and pricing",
        text:
          "Sessions, packages, pricing and practical information are presented so clients can quickly understand what you offer.",
      },
      {
        icon: "mobile",
        title:
          "Fast mobile experience",
        text:
          "The structure, imagery and interface are designed mobile first, with a focus on speed, clarity and a polished experience.",
      },
      {
        icon: "search",
        title:
          "SEO and visibility",
        text:
          "Page structure, headings, metadata, crawler-friendly content and dedicated service or location landing pages can be considered from the beginning.",
      },
      {
        icon: "language",
        title:
          "Language versions",
        text:
          "The website can be built in one or several languages, such as Finnish and English, Finnish and Swedish or another suitable combination.",
      },
      {
        icon: "contact",
        title:
          "Contact and management",
        text:
          "A clear inquiry path, contact form and WordPress content management make the website easy to use for both clients and the photographer.",
      },
    ],

    demoEyebrow:
      "Photography Premium · Demo",

    demoTitle:
      "See what a modern photographer website can look like",

    demoLead:
      "The Photography Premium demo shows one possible structure and visual direction. The final website is not a one-size-fits-all theme: colours, imagery, typography, copy, services and content are adapted to the client's own brand.",

    demoItems: [
      "Home page with a strong visual hero",
      "Portfolio",
      "Sessions / services",
      "Pricing",
      "About the photographer",
      "Studio / premises page when needed",
      "Contact and inquiry path",
      "FI / EN language versions",
      "Ivory / Noir theme options in the demo",
      "Responsive mobile and desktop implementation",
    ],

    demoCta:
      "Open the Photography Premium demo",

    packagesEyebrow:
      "Implementation options",

    packagesTitle:
      "Choose the right scope",

    packagesLead:
      "The packages describe project scope, not ready-made templates. Every website is designed around the photographer's own brand, imagery, services and goals, and content or functionality can be added, removed or combined as needed.",

    recommended:
      "Recommended package",

    packages: [
      {
        id:
          "essential",
        name:
          "Essential",
        prefix:
          "from",
        price:
          "€1,490",
        description:
          "A professional website containing the essential pages needed to present your work and services.",
        features: [
          "Home",
          "Portfolio",
          "Services / sessions",
          "Pricing when needed",
          "About",
          "Contact + form",
          "Social and contact details",
          "1 language version",
          "WordPress content management",
          "Core search optimisation",
        ],
      },
      {
        id:
          "premium",
        name:
          "Premium",
        prefix:
          "from",
        price:
          "€2,490",
        featured:
          true,
        description:
          "A broader package for photographers who want more content, functionality and a stronger foundation for search visibility.",
        features: [
          "Everything in Essential",
          "2 language versions",
          "Testimonials",
          "FAQ",
          "Studio / premises page when needed",
          "Extended content management",
          "Additional calls to action",
          "Visitor analytics",
          "Cookie management",
          "Extended search visibility",
          "3 SEO landing pages",
        ],
      },
      {
        id:
          "custom",
        name:
          "Custom",
        prefix:
          "from",
        price:
          "€3,490",
        description:
          "A broader fully custom implementation when the project needs individual pages, functionality, integrations or a more extensive search visibility solution.",
        features: [
          "Everything in Premium",
          "Multiple language versions",
          "Custom pages and sections",
          "5–10+ SEO landing pages",
          "Extended visibility strategy",
          "Booking solutions",
          "Custom integrations",
          "Specialised forms",
          "Extended content migration",
        ],
      },
    ],

    seoEyebrow:
      "Visibility in search",

    seoTitle:
      "A great portfolio cannot help if potential clients never find it",

    seoLead:
      "The website can also be built to actively attract new clients. Services, imagery, headings and page structure are planned so search engines can understand what you offer and where you work.",

    seoLandingTitle:
      "SEO landing pages",

    seoLandingText:
      "An SEO landing page is a dedicated service or location page built around a specific search. Premium includes three landing pages and Custom includes 5–10 or more depending on the project.",

    seoExamples:
      "For example: Wedding photographer Helsinki · Business photographer Espoo · Portrait photography Vantaa",

    processTitle:
      "How the project works",

    process: [
      {
        title:
          "1. Style and goals",
        text:
          "We review your current website, photography style, services, customers and what the new website needs to achieve.",
      },
      {
        title:
          "2. Design and staging",
        text:
          "I build the website on a staging address. You can follow the progress and comment on structure, content and visual direction before launch.",
      },
      {
        title:
          "3. Final polish and launch",
        text:
          "Content, mobile views, forms, core SEO and technical functionality are checked before the new website goes live.",
      },
    ],

    faqTitle:
      "Frequently asked questions about photographer websites",

    faqLead:
      "Common questions before starting a Photography Premium project.",

    faq: [
      {
        q:
          "How much does a photographer website cost?",
        a:
          "Photography Premium projects start from €1,490. Premium starts from €2,490 and the broader Custom package from €3,490. The final price depends on page count, language versions, content and additional functionality.",
      },
      {
        q:
          "Can I update photos and content myself?",
        a:
          "Yes. The implementation can include WordPress content management so portfolios, copy, services and other content can be updated without editing code.",
      },
      {
        q:
          "Will my website look exactly like the Photography Premium demo?",
        a:
          "No. The demo shows one possible structure and visual direction. The final website is adapted to your imagery, colours, typography, services, copy and brand.",
      },
      {
        q:
          "Can content from my old website be migrated?",
        a:
          "Yes. Existing copy, images and other useful content can be transferred into the new website. Larger content migrations can be included in the project scope.",
      },
      {
        q:
          "Can the website have multiple languages?",
        a:
          "Yes. Essential includes one language version and Premium includes two. Additional languages can be added when needed.",
      },
      {
        q:
          "Can booking be added?",
        a:
          "Yes. Booking can be implemented according to the project either through an existing service integration or a broader custom solution.",
      },
      {
        q:
          "What is an SEO landing page?",
        a:
          "An SEO landing page is a dedicated page built around a specific service or local search, for example 'wedding photographer Helsinki' or 'business photographer Espoo'.",
      },
      {
        q:
          "How long does the project take?",
        a:
          "The timeline is agreed project by project depending on content, language versions and scope. A staging version lets you follow progress before launch.",
      },
      {
        q:
          "Can hosting and maintenance be included?",
        a:
          "Yes. Hosting and ongoing technical maintenance can be arranged separately as part of the overall service.",
      },
    ],

    finalTitle:
      "Want a website that looks as good as your photography?",

    finalLead:
      "Explore the Photography Premium demo first. If the direction feels right, request a quote and tell me briefly about your current website and what you would like to improve.",
  },

  es: {
    badge:
      "Photography Premium · Webs para fotógrafos",

    title:
      "Una web para fotógrafos cuyo trabajo merece una mejor presentación",

    lead:
      "Creo webs totalmente a medida, visuales y rápidas para fotógrafos, combinando portfolio, servicios, precios, contacto y visibilidad en buscadores en una experiencia clara. La web no se adapta a una plantilla prefabricada: la estructura y el estilo se construyen alrededor del trabajo y la marca del fotógrafo. Los proyectos Photography Premium empiezan desde 1.490 €.",

    primaryCta:
      "Ver demo Photography Premium",

    secondaryCta:
      "Pedir presupuesto",

    trust: [
      "Portfolio primero",
      "Móvil primero",
      "Gestión con WordPress",
      "Base SEO incluida",
    ],

    whoTitle:
      "¿Para quién es Photography Premium?",

    whoLead:
      "Especialmente para fotógrafos cuya web debe estar al nivel de su trabajo y facilitar al máximo el contacto de nuevos clientes.",

    who: [
      "Fotógrafos de boda y parejas",
      "Retrato, familia y lifestyle",
      "Fotografía corporativa y de marca",
      "Fotógrafos de estudio y retrato",
      "Fotógrafos con una web antigua, lenta o difícil de usar en móvil",
      "Fotógrafos que quieren mejorar su visibilidad en buscadores",
    ],

    featuresTitle:
      "¿Qué se puede construir para una web de fotografía?",

    features: [
      {
        icon: "portfolio",
        title:
          "Portfolio visual",
        text:
          "Las imágenes ocupan el centro con un portfolio limpio y responsive que funciona bien tanto en móvil como en pantallas grandes.",
      },
      {
        icon: "camera",
        title:
          "Servicios y precios",
        text:
          "Sesiones, paquetes, precios e información práctica se presentan de forma clara para ayudar al cliente a decidir.",
      },
      {
        icon: "mobile",
        title:
          "Experiencia móvil rápida",
        text:
          "La estructura, las imágenes y la interfaz se diseñan pensando primero en móvil, con foco en velocidad y claridad.",
      },
      {
        icon: "search",
        title:
          "SEO y visibilidad",
        text:
          "Estructura, títulos, metadatos, contenido legible para buscadores y páginas específicas de servicio o ubicación desde el principio.",
      },
      {
        icon: "language",
        title:
          "Versiones de idioma",
        text:
          "La web puede realizarse en uno o varios idiomas según las necesidades del cliente.",
      },
      {
        icon: "contact",
        title:
          "Contacto y gestión",
        text:
          "Un camino claro de contacto, formulario y gestión de contenido con WordPress facilitan el uso para el cliente y el fotógrafo.",
      },
    ],

    demoEyebrow:
      "Photography Premium · Demo",

    demoTitle:
      "Mira cómo puede ser una web moderna para fotografía",

    demoLead:
      "La demo de Photography Premium muestra una posible estructura y dirección visual. La web final no es una plantilla idéntica para todos: colores, imágenes, tipografía, textos, servicios y contenido se adaptan a la marca de cada cliente.",

    demoItems: [
      "Inicio con hero visual",
      "Portfolio",
      "Sesiones / servicios",
      "Precios",
      "Sobre el fotógrafo",
      "Estudio / espacio cuando sea necesario",
      "Contacto y solicitud de presupuesto",
      "Versiones FI / EN en la demo",
      "Opciones Ivory / Noir en la demo",
      "Diseño responsive para móvil y escritorio",
    ],

    demoCta:
      "Abrir demo Photography Premium",

    packagesEyebrow:
      "Opciones de implementación",

    packagesTitle:
      "Elige el alcance adecuado",

    packagesLead:
      "Los paquetes describen el alcance del proyecto, no plantillas prediseñadas. Cada web se diseña alrededor de la marca, las imágenes, los servicios y los objetivos del fotógrafo, y el contenido o las funciones pueden ajustarse según necesidad.",

    recommended:
      "Paquete recomendado",

    packages: [
      {
        id:
          "essential",
        name:
          "Essential",
        prefix:
          "desde",
        price:
          "1.490 €",
        description:
          "Una web profesional con las páginas esenciales para presentar el trabajo y los servicios.",
        features: [
          "Inicio",
          "Portfolio",
          "Servicios / sesiones",
          "Precios cuando sea necesario",
          "Sobre el fotógrafo",
          "Contacto + formulario",
          "Redes y datos de contacto",
          "1 idioma",
          "Gestión de contenido con WordPress",
          "SEO básico",
        ],
      },
      {
        id:
          "premium",
        name:
          "Premium",
        prefix:
          "desde",
        price:
          "2.490 €",
        featured:
          true,
        description:
          "Una solución más amplia para fotógrafos que quieren más contenido, funciones y una base más fuerte para buscadores.",
        features: [
          "Todo lo incluido en Essential",
          "2 idiomas",
          "Testimonios",
          "FAQ",
          "Página de estudio / espacio",
          "Gestión de contenido ampliada",
          "Más llamadas a la acción",
          "Analítica de visitantes",
          "Gestión de cookies",
          "Visibilidad ampliada",
          "3 landing pages SEO",
        ],
      },
      {
        id:
          "custom",
        name:
          "Custom",
        prefix:
          "desde",
        price:
          "3.490 €",
        description:
          "Una implementación totalmente a medida cuando se necesitan páginas individuales, funciones, integraciones o una solución de visibilidad más amplia.",
        features: [
          "Todo lo incluido en Premium",
          "Varios idiomas",
          "Páginas y secciones personalizadas",
          "5–10+ landing pages SEO",
          "Estrategia de visibilidad ampliada",
          "Soluciones de reservas",
          "Integraciones personalizadas",
          "Formularios especiales",
          "Migración de contenido ampliada",
        ],
      },
    ],

    seoEyebrow:
      "Visibilidad en buscadores",

    seoTitle:
      "Un gran portfolio no ayuda si los clientes no lo encuentran",

    seoLead:
      "La web también puede construirse para atraer nuevos clientes activamente. Servicios, imágenes, títulos y estructura se diseñan para que los buscadores entiendan qué ofreces y dónde trabajas.",

    seoLandingTitle:
      "Landing pages SEO",

    seoLandingText:
      "Una landing SEO es una página específica de servicio o ubicación creada alrededor de una búsqueda concreta. Premium incluye tres y Custom incluye 5–10 o más según el proyecto.",

    seoExamples:
      "Por ejemplo: Fotógrafo de bodas Helsinki · Fotógrafo corporativo Espoo · Retratos Vantaa",

    processTitle:
      "Cómo avanza el proyecto",

    process: [
      {
        title:
          "1. Estilo y objetivos",
        text:
          "Revisamos tu web actual, estilo fotográfico, servicios, clientes y qué debe conseguir la nueva web.",
      },
      {
        title:
          "2. Diseño y staging",
        text:
          "Construyo la web en una dirección de staging para que puedas seguir el progreso y comentar estructura, contenido y diseño antes del lanzamiento.",
      },
      {
        title:
          "3. Acabado y publicación",
        text:
          "Contenido, móvil, formularios, SEO básico y funcionamiento técnico se revisan antes de publicar la nueva web.",
      },
    ],

    faqTitle:
      "Preguntas frecuentes sobre webs para fotógrafos",

    faqLead:
      "Preguntas habituales antes de empezar un proyecto Photography Premium.",

    faq: [
      {
        q:
          "¿Cuánto cuesta una web para fotógrafo?",
        a:
          "Los proyectos Photography Premium empiezan desde 1.490 €. Premium empieza desde 2.490 € y Custom desde 3.490 €. El precio final depende del número de páginas, idiomas, contenido y funciones adicionales.",
      },
      {
        q:
          "¿Puedo actualizar fotos y contenido yo mismo?",
        a:
          "Sí. La implementación puede incluir gestión de contenido con WordPress para actualizar portfolios, textos, servicios y otros contenidos sin editar código.",
      },
      {
        q:
          "¿Mi web será igual que la demo Photography Premium?",
        a:
          "No. La demo muestra una posible estructura y dirección visual. La web final se adapta a tus imágenes, colores, tipografía, servicios, textos y marca.",
      },
      {
        q:
          "¿Se puede migrar contenido de mi web antigua?",
        a:
          "Sí. Se pueden transferir textos, imágenes y otros contenidos útiles. Una migración más amplia puede incluirse en el alcance del proyecto.",
      },
      {
        q:
          "¿Puede tener varios idiomas?",
        a:
          "Sí. Essential incluye un idioma y Premium dos. Se pueden añadir más cuando sea necesario.",
      },
      {
        q:
          "¿Se puede añadir un sistema de reservas?",
        a:
          "Sí. Las reservas pueden implementarse mediante una integración existente o una solución personalizada más amplia.",
      },
      {
        q:
          "¿Qué es una landing page SEO?",
        a:
          "Es una página específica creada alrededor de un servicio o búsqueda local, por ejemplo 'fotógrafo de bodas Helsinki' o 'fotógrafo corporativo Espoo'.",
      },
      {
        q:
          "¿Cuánto tarda el proyecto?",
        a:
          "El calendario se acuerda según el contenido, idiomas y alcance. Una versión de staging permite seguir el progreso antes de la publicación.",
      },
      {
        q:
          "¿Se puede incluir hosting y mantenimiento?",
        a:
          "Sí. Hosting y mantenimiento técnico continuo pueden acordarse por separado como parte del servicio.",
      },
    ],

    finalTitle:
      "¿Quieres una web que se vea tan bien como tus fotografías?",

    finalLead:
      "Mira primero la demo Photography Premium. Si la dirección te convence, pide presupuesto y cuéntame brevemente qué quieres mejorar de tu web actual.",
  },
};

const iconMap = {
  portfolio:
    FaImages,
  camera:
    FaCamera,
  mobile:
    FaMobileAlt,
  search:
    FaSearch,
  language:
    FaLanguage,
  contact:
    FaEnvelope,
};

function buildEmailUrl(
  lang,
  contactEmail = CONTACT_EMAIL
) {
  const subject =
    lang === "en"
      ? "Photography Premium – Quote request"
      : lang === "es"
      ? "Photography Premium – Solicitud de presupuesto"
      : "Photography Premium – Tarjouspyyntö";

  const body =
    lang === "en"
      ? "Hi Arttu,\n\nI am interested in Photography Premium and would like to request a quote.\n\nMy current website:\n\nWhat I would like to improve:\n\n"
      : lang === "es"
      ? "Hola Arttu,\n\nEstoy interesado en Photography Premium y me gustaría pedir presupuesto.\n\nMi web actual:\n\nQué me gustaría mejorar:\n\n"
      : "Hei Arttu,\n\nOlen kiinnostunut Photography Premium -verkkosivuratkaisusta ja haluaisin pyytää tarjouksen.\n\nNykyinen verkkosivuni:\n\nMitä haluaisin uudistaa:\n\n";

  return `mailto:${contactEmail}?subject=${encodeURIComponent(
    subject
  )}&body=${encodeURIComponent(
    body
  )}`;
}

export default function PhotographerWebsiteLandingPage({
  lang = "fi",
  prefix = "",
}) {
  const siteContent = useSiteContent();
  const currentLang =
    lang === "en" ||
    lang === "es"
      ? lang
      : "fi";

  const t = deepMerge(
    copy[currentLang],
    siteContent?.pages?.photographer?.[currentLang] || {}
  );

  const contactEmail =
    siteContent?.settings?.photographerEmail || CONTACT_EMAIL;

  const demoUrl =
    siteContent?.settings?.photographerDemoUrl || DEMO_URL;

  const emailUrl =
    buildEmailUrl(
      currentLang,
      contactEmail
    );

  return (
    <>
      <main className="mx-auto w-full max-w-7xl px-6 pb-24 pt-28 md:px-10 lg:px-16">
        {/* =========================================================
            HERO
            ========================================================= */}

        <section className="relative overflow-hidden rounded-[2rem] border border-black/10 bg-white/75 px-6 py-12 text-center shadow-[0_20px_80px_rgba(0,0,0,0.12)] backdrop-blur dark:border-white/10 dark:bg-white/5 md:px-10 md:py-16">
          <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-amber-300/15 blur-3xl" />
          <div className="pointer-events-none absolute -bottom-24 -right-24 h-80 w-80 rounded-full bg-stone-300/20 blur-3xl dark:bg-white/10" />

          <div className="relative z-10">
            <div className="mb-5 inline-flex rounded-full border border-amber-500/25 bg-amber-300/10 px-4 py-2 text-xs font-bold uppercase tracking-wide text-amber-900 dark:border-amber-300/20 dark:text-amber-200">
              {t.badge}
            </div>

            <h1 className="mx-auto max-w-5xl text-4xl font-black tracking-tight text-gray-950 dark:text-white md:text-6xl">
              {t.title}
            </h1>

            <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-gray-700 dark:text-gray-200">
              {t.lead}
            </p>

            <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <a
                href={
                  demoUrl
                }
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 rounded-full bg-gray-950 px-6 py-3 font-bold text-white shadow-lg transition hover:scale-[1.02] dark:bg-white dark:text-gray-950"
              >
                <FaExternalLinkAlt className="h-4 w-4" />

                {
                  t.primaryCta
                }
              </a>

              <a
                href={
                  emailUrl
                }
                className="inline-flex items-center gap-2 rounded-full border border-black/10 bg-white/80 px-6 py-3 font-semibold text-gray-950 backdrop-blur transition hover:-translate-y-[1px] dark:border-white/10 dark:bg-white/5 dark:text-white"
              >
                <FaEnvelope className="h-4 w-4" />

                {
                  t.secondaryCta
                }
              </a>
            </div>

            <div className="mt-7 flex flex-wrap justify-center gap-2">
              {t.trust.map(
                (
                  item
                ) => (
                  <span
                    key={
                      item
                    }
                    className="rounded-full border border-black/10 bg-white/70 px-3 py-1 text-xs font-bold text-gray-700 dark:border-white/10 dark:bg-black/20 dark:text-gray-200"
                  >
                    {
                      item
                    }
                  </span>
                )
              )}
            </div>
          </div>
        </section>

        {/* =========================================================
            WHO + FEATURES
            ========================================================= */}

        <section className="mt-14 grid gap-6 lg:grid-cols-[0.82fr_1.18fr]">
          <div className="rounded-[2rem] border border-black/10 bg-white/70 p-6 shadow-[0_20px_80px_rgba(0,0,0,0.08)] backdrop-blur-xl dark:border-white/10 dark:bg-white/[0.04] dark:shadow-[0_20px_80px_rgba(0,0,0,0.25)]">
            <h2 className="text-2xl font-black text-gray-950 dark:text-white">
              {
                t.whoTitle
              }
            </h2>

            <p className="mt-3 text-gray-700 dark:text-gray-200">
              {
                t.whoLead
              }
            </p>

            <ul className="mt-6 space-y-3 text-gray-800 dark:text-gray-100">
              {t.who.map(
                (
                  item
                ) => (
                  <li
                    key={
                      item
                    }
                    className="flex items-start gap-3"
                  >
                    <span className="mt-1 inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-amber-300/20 text-amber-800 dark:text-amber-200">
                      <FaCheck className="h-3 w-3" />
                    </span>

                    <span>
                      {
                        item
                      }
                    </span>
                  </li>
                )
              )}
            </ul>
          </div>

          <div className="rounded-[2rem] border border-black/10 bg-white/70 p-6 shadow-[0_20px_80px_rgba(0,0,0,0.08)] backdrop-blur-xl dark:border-white/10 dark:bg-white/[0.04] dark:shadow-[0_20px_80px_rgba(0,0,0,0.25)]">
            <h2 className="text-2xl font-black text-gray-950 dark:text-white">
              {
                t.featuresTitle
              }
            </h2>

            <div className="mt-6 grid gap-4 sm:grid-cols-2">
              {t.features.map(
                (
                  item
                ) => {
                  const Icon =
                    iconMap[
                      item
                        .icon
                    ] ||
                    FaCamera;

                  return (
                    <div
                      key={
                        item.title
                      }
                      className="rounded-2xl border border-black/10 bg-white/80 p-5 transition hover:-translate-y-1 hover:shadow-xl dark:border-white/10 dark:bg-white/5"
                    >
                      <div className="mb-3 inline-flex h-10 w-10 items-center justify-center rounded-full bg-amber-300/20 text-amber-800 dark:text-amber-200">
                        <Icon className="h-4 w-4" />
                      </div>

                      <h3 className="font-black text-gray-950 dark:text-white">
                        {
                          item.title
                        }
                      </h3>

                      <p className="mt-2 text-sm leading-relaxed text-gray-700 dark:text-gray-200">
                        {
                          item.text
                        }
                      </p>
                    </div>
                  );
                }
              )}
            </div>
          </div>
        </section>

        {/* =========================================================
            PHOTOGRAPHY PREMIUM DEMO
            ========================================================= */}

        <section className="mt-14 overflow-hidden rounded-[2rem] border border-amber-500/25 bg-white/80 p-6 shadow-[0_20px_80px_rgba(0,0,0,0.08)] backdrop-blur-xl dark:border-amber-300/20 dark:bg-white/[0.04] dark:shadow-[0_20px_80px_rgba(0,0,0,0.25)] md:p-8">
          <div className="grid gap-8 lg:grid-cols-[0.9fr_1.1fr] lg:items-center">
            <div>
              <p className="text-xs font-black uppercase tracking-[0.25em] text-amber-800 dark:text-amber-200">
                {
                  t.demoEyebrow
                }
              </p>

              <h2 className="mt-4 text-3xl font-black text-gray-950 dark:text-white md:text-4xl">
                {
                  t.demoTitle
                }
              </h2>

              <p className="mt-4 text-lg leading-relaxed text-gray-800 dark:text-gray-100">
                {
                  t.demoLead
                }
              </p>

              <a
                href={
                  demoUrl
                }
                target="_blank"
                rel="noopener noreferrer"
                className="mt-6 inline-flex items-center gap-2 rounded-full bg-gray-950 px-6 py-3 font-bold text-white transition hover:scale-[1.02] dark:bg-white dark:text-gray-950"
              >
                <FaExternalLinkAlt className="h-4 w-4" />

                {
                  t.demoCta
                }
              </a>
            </div>

            <div className="rounded-2xl border border-black/10 bg-white/80 p-5 dark:border-white/10 dark:bg-white/5">
              <ul className="grid gap-3 sm:grid-cols-2">
                {t.demoItems.map(
                  (
                    item
                  ) => (
                    <li
                      key={
                        item
                      }
                      className="flex items-start gap-3 text-sm leading-relaxed text-gray-700 dark:text-gray-200"
                    >
                      <FaCheck className="mt-1 h-3.5 w-3.5 shrink-0 text-amber-700 dark:text-amber-200" />

                      <span>
                        {
                          item
                        }
                      </span>
                    </li>
                  )
                )}
              </ul>
            </div>
          </div>
        </section>

        {/* =========================================================
            PACKAGES
            ========================================================= */}

        <section className="mt-14 rounded-[2rem] border border-black/10 bg-white/70 p-6 shadow-[0_20px_80px_rgba(0,0,0,0.08)] backdrop-blur-xl dark:border-white/10 dark:bg-white/[0.04] dark:shadow-[0_20px_80px_rgba(0,0,0,0.25)] md:p-8">
          <div className="mx-auto max-w-3xl text-center">
            <p className="text-xs font-black uppercase tracking-[0.25em] text-amber-800 dark:text-amber-200">
              {
                t.packagesEyebrow
              }
            </p>

            <h2 className="mt-3 text-3xl font-black text-gray-950 dark:text-white md:text-4xl">
              {
                t.packagesTitle
              }
            </h2>

            <p className="mt-4 leading-relaxed text-gray-700 dark:text-gray-200">
              {
                t.packagesLead
              }
            </p>
          </div>

          <div className="mt-8 grid gap-5 lg:grid-cols-3">
            {t.packages.map(
              (
                item
              ) => (
                <article
                  key={
                    item.id
                  }
                  className={`relative flex flex-col rounded-3xl border p-6 ${
                    item.featured
                      ? "border-amber-500/40 bg-amber-50/70 shadow-xl dark:border-amber-300/30 dark:bg-amber-300/5"
                      : "border-black/10 bg-white/80 dark:border-white/10 dark:bg-white/5"
                  }`}
                >
                  {item.featured && (
                    <span className="mb-5 inline-flex w-fit rounded-full bg-gray-950 px-3 py-1.5 text-[10px] font-bold uppercase tracking-[0.16em] text-white dark:bg-white dark:text-gray-950">
                      {
                        t.recommended
                      }
                    </span>
                  )}

                  <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
                    <h3 className="text-2xl font-black text-gray-950 dark:text-white">
                      {
                        item.name
                      }
                    </h3>

                    <div className="shrink-0 sm:text-right">
                      <p className="m-0 text-[10px] font-bold uppercase tracking-[0.16em] text-gray-500 dark:text-gray-400">
                        {
                          item.prefix
                        }
                      </p>

                      <p className="m-0 mt-1 whitespace-nowrap text-2xl font-black text-gray-950 dark:text-white">
                        {
                          item.price
                        }
                      </p>
                    </div>
                  </div>

                  <p className="mt-5 text-sm leading-relaxed text-gray-700 dark:text-gray-200">
                    {
                      item.description
                    }
                  </p>

                  <ul className="mt-6 border-t border-black/10 dark:border-white/10">
                    {item.features.map(
                      (
                        feature
                      ) => (
                        <li
                          key={
                            feature
                          }
                          className="flex gap-3 border-b border-black/10 py-3 text-sm leading-relaxed text-gray-800 dark:border-white/10 dark:text-gray-100"
                        >
                          <FaCheck className="mt-1 h-3.5 w-3.5 shrink-0 text-amber-700 dark:text-amber-200" />

                          <span>
                            {
                              feature
                            }
                          </span>
                        </li>
                      )
                    )}
                  </ul>
                </article>
              )
            )}
          </div>
        </section>

        {/* =========================================================
            SEO
            ========================================================= */}

        <section className="mt-14 overflow-hidden rounded-[2rem] border border-black/10 bg-white/70 shadow-[0_20px_80px_rgba(0,0,0,0.08)] backdrop-blur-xl dark:border-white/10 dark:bg-white/[0.04] dark:shadow-[0_20px_80px_rgba(0,0,0,0.25)]">
          <div className="grid lg:grid-cols-2">
            <div className="p-6 md:p-8">
              <p className="text-xs font-black uppercase tracking-[0.25em] text-amber-800 dark:text-amber-200">
                {
                  t.seoEyebrow
                }
              </p>

              <h2 className="mt-4 text-3xl font-black text-gray-950 dark:text-white md:text-4xl">
                {
                  t.seoTitle
                }
              </h2>

              <p className="mt-4 leading-relaxed text-gray-700 dark:text-gray-200">
                {
                  t.seoLead
                }
              </p>
            </div>

            <div className="border-t border-black/10 bg-gray-50/80 p-6 dark:border-white/10 dark:bg-black/20 md:p-8 lg:border-l lg:border-t-0">
              <h3 className="text-2xl font-black text-gray-950 dark:text-white">
                {
                  t.seoLandingTitle
                }
              </h3>

              <p className="mt-4 leading-relaxed text-gray-700 dark:text-gray-200">
                {
                  t.seoLandingText
                }
              </p>

              <p className="mt-5 border-l-2 border-amber-500 pl-4 text-sm leading-relaxed text-gray-600 dark:border-amber-300 dark:text-gray-300">
                {
                  t.seoExamples
                }
              </p>
            </div>
          </div>
        </section>

        {/* =========================================================
            PROCESS
            ========================================================= */}

        <section className="mt-14 rounded-[2rem] border border-black/10 bg-white/70 p-6 shadow-[0_20px_80px_rgba(0,0,0,0.08)] backdrop-blur-xl dark:border-white/10 dark:bg-white/[0.04] dark:shadow-[0_20px_80px_rgba(0,0,0,0.25)] md:p-8">
          <h2 className="text-3xl font-black text-gray-950 dark:text-white">
            {
              t.processTitle
            }
          </h2>

          <div className="mt-6 grid gap-4 lg:grid-cols-3">
            {t.process.map(
              (
                item
              ) => (
                <div
                  key={
                    item.title
                  }
                  className="rounded-2xl border border-black/10 bg-white/80 p-5 transition hover:-translate-y-1 hover:shadow-xl dark:border-white/10 dark:bg-white/5"
                >
                  <h3 className="font-black text-gray-950 dark:text-white">
                    {
                      item.title
                    }
                  </h3>

                  <p className="mt-2 text-sm leading-relaxed text-gray-700 dark:text-gray-200">
                    {
                      item.text
                    }
                  </p>
                </div>
              )
            )}
          </div>
        </section>

        {/* =========================================================
            FAQ
            ========================================================= */}

        <section className="mt-14 rounded-[2rem] border border-black/10 bg-white/70 p-6 shadow-[0_20px_80px_rgba(0,0,0,0.08)] backdrop-blur-xl dark:border-white/10 dark:bg-white/[0.04] dark:shadow-[0_20px_80px_rgba(0,0,0,0.25)] md:p-8">
          <div className="mx-auto max-w-3xl text-center">
            <p className="text-xs font-black uppercase tracking-[0.25em] text-amber-800 dark:text-amber-200">
              FAQ
            </p>

            <h2 className="mt-3 text-3xl font-black text-gray-950 dark:text-white">
              {
                t.faqTitle
              }
            </h2>

            <p className="mt-4 leading-relaxed text-gray-700 dark:text-gray-200">
              {
                t.faqLead
              }
            </p>
          </div>

          <div className="mt-8 grid gap-4 md:grid-cols-2">
            {t.faq.map(
              (
                item
              ) => (
                <article
                  key={
                    item.q
                  }
                  className="rounded-2xl border border-black/10 bg-gray-50/80 p-5 transition hover:-translate-y-1 hover:border-amber-400/50 dark:border-white/10 dark:bg-black/20"
                >
                  <h3 className="text-lg font-black text-gray-950 dark:text-white">
                    {
                      item.q
                    }
                  </h3>

                  <p className="mt-3 text-sm leading-relaxed text-gray-700 dark:text-gray-200">
                    {
                      item.a
                    }
                  </p>
                </article>
              )
            )}
          </div>
        </section>

        {/* =========================================================
            FINAL CTA
            ========================================================= */}

        <section className="mt-14 rounded-[2rem] border border-amber-500/30 bg-amber-300/10 p-8 text-center shadow-[0_20px_80px_rgba(0,0,0,0.08)] dark:shadow-[0_20px_80px_rgba(0,0,0,0.25)] md:p-10">
          <h2 className="mx-auto max-w-3xl text-3xl font-black text-gray-950 dark:text-white md:text-4xl">
            {
              t.finalTitle
            }
          </h2>

          <p className="mx-auto mt-4 max-w-2xl leading-relaxed text-gray-700 dark:text-gray-200">
            {
              t.finalLead
            }
          </p>

          <div className="mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href={
                demoUrl
              }
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 rounded-full bg-gray-950 px-7 py-3 font-bold text-white shadow-lg transition hover:scale-[1.02] dark:bg-white dark:text-gray-950"
            >
              <FaExternalLinkAlt className="h-4 w-4" />

              {
                t.primaryCta
              }
            </a>

            <a
              href={
                emailUrl
              }
              className="inline-flex items-center gap-2 rounded-full border border-black/10 bg-white/80 px-7 py-3 font-semibold text-gray-950 backdrop-blur transition hover:-translate-y-[1px] dark:border-white/10 dark:bg-white/5 dark:text-white"
            >
              <FaEnvelope className="h-4 w-4" />

              {
                t.secondaryCta
              }
            </a>
          </div>
        </section>
      </main>

      <Footer
        lang={currentLang}
        prefix={prefix}
      />
    </>
  );
}
